import { ref } from 'vue';
import { defineStore } from 'pinia';

import type { MapFeatureOverlayItem } from '@/stores/types/mapStoreContracts';


/*
Это промежуточный стор, в который мы закидываем визуальное представление фичей для целей,
чтобы знать, в каких местах у нас будут отображаться какие поп-апы.
Данные для этих поп-апов у нас уже из другого места идут.

[{
	featureType: feature.get('type'),
	featureData: feature.get('featureData'),
	coords: {
		left: coords[0] + 'px',
		top: coords[1] + 'px',
	},
}]
*/
export const useMapFeaturesStore = defineStore('mapFeaturesStore', () => {
	const features = ref<MapFeatureOverlayItem[]>([]);
	const updateFeatures = (featuresValue: MapFeatureOverlayItem[]): void => {
		features.value = featuresValue;
	};

	return {
		features,
		updateFeatures,
	};
});
